export interface DayMonthYearDate {
    day: string;
    month: string;
    year: string;
}

export function formatDateToDayMonthYear(date: Date | null | undefined): DayMonthYearDate | null {
    if (!date) {
        return null;
    }

    return {
        day: `${date.getDate()}`,
        month: `${date.getMonth() + 1}`,
        year: `${date.getFullYear()}`,
    };
}

export function adjustDateToUserTimezone(date: string | Date | null | undefined): Date | null {
    if (!date) {
        return null;
    }

    const tempDate = new Date(date);
    const userTimezoneOffset = tempDate.getTimezoneOffset() * 60000;
    return new Date(tempDate.getTime() + userTimezoneOffset);
}

